import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import FormTextField from '../../../../components/FormTextField';
import { useTheme } from '@emotion/react';
import * as yup from 'yup';
import { matchIsValidTel } from 'mui-tel-input';
import { Formik, Form } from 'formik';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import { buttonStyle1, buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import appapi from '../../../../api/apiClient';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import { initCompanyDetails, initUserData } from '../../../../redux/features/authSlice';
import uploadFileToS3 from '../../../../utils/fileUpload';
import PhoneTextField from '../../../../components/PhoneTextField';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    // alignItems: 'center',
    // WebkitAlignItems: 'center',
    // WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
  },
};

const validationSchema = yup.object({
  name: yup.string('Full Name').min(3, 'Full Name should be atleast 3 character').max(100, 'Maximum Character Limit 100').required(' '),
  phone: yup
    .string('Phone Number')
    .required()
    .test('is-valid-number', 'Mobile Number is Invalid', (value) => {
      if (value) {
        return matchIsValidTel(value);
      }

      return false;
    }),
  designation: yup.string('Designation').required(' ').min(3, 'Designation should be atleast 3 character').max(50, 'Maximum Character Limit 50'),
});

export default function EditProfile({ modelOpen, handleClose }) {
  const theme = useTheme();
  const formRef = useRef();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { t } = useTranslation();

  const handleUpdateCompany = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.put(`/user/profile`, values);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        dispatch(initUserData());
        handleClose(true);
        showmessage(data.message, 'success');
        dispatch(setLoading(false));
      } else {
        showmessage(data.message, 'error');
        dispatch(setLoading(false));
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return modelOpen ? (
    <Formik
      innerRef={formRef}
      enableReinitialize={false}
      initialValues={{
        name: user?.name || '',
        email: user?.email || '',
        designation: user?.designation || '',
        phoneNumber: user?.phoneNumber || '',
        roleId: user?.roleId || '',
        country: user?.country || '',
        phoneCode: user?.phoneCode || '',
        phone: (user.phoneCode || '') + (user?.phoneNumber || ''),
        address: user?.address || '',
        companyId: user?.companyId || '',
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        if(validationSchema.validate(values)) {
          handleUpdateCompany(values);
        }
        
      }}
    >
      {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
        <Form autoComplete="off">
          <Dialog
            sx={sx}
            open={modelOpen}
            scroll="paper"
          >
            <DialogTitle
              className="fw-medium fs-14 ff-Roboto !uppercase"
              color={theme.palette.primary.text}
              sx={{ m: 0, p: 2 }}
              id="customized-dialog-title"
            >
              {t('Profile Details')}
            </DialogTitle>
            <IconButton
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <ClearIcon
                style={{ transform: 'scale(1)', color: 'rgba(20, 40, 90,0.5)' }}
                onClick={() => {
                  handleClose();
                }}
              />
            </IconButton>
            <DialogContent dividers>
              <Stack
                style={{ backgroundColor: 'white', borderRadius: '8px' }}
                className=""
              >
                <Stack>
                  <FormTextField
                    outlineLabel={t('Full name')}
                    name="name"
                    requiredMark={true}
                    onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 101 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Designation')}
                    name="designation"
                    requiredMark={true}
                    onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 101 }}
                  />
                </Stack>
                <Stack>
                  <PhoneTextField
                    required
                    variant="outlined"
                    label={t('Phone number')}
                    name="phone"
                    name2="phoneNumber"
                    name3="phoneCode"
                  />
                </Stack>
              </Stack>
            </DialogContent>
            <DialogActions>
              <Button
                type="button"
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    textTransform: "uppercase",
                    '&:hover': {},
                  },
                ]}
                onClick={handleClose}
              >
                {t('Close')}
              </Button>
              <Button
                disabled={!(dirty && isValid)}
                onClick={() => formRef?.current?.handleSubmit()}
                variant="contained"
                sx={[
                  buttonStyle2,
                  {
                    color: '#fff',
                    backgroundColor: theme.palette.primary.main,
                    textTransform: "uppercase",
                    '&:hover': {
                      backgroundColor: theme.palette.background.main,
                      color: '#fff',
                      textTransform: "uppercase"
                    },
                    '&:disabled': {
                      color: 'rgba(255,255,255,0.5)',
                      backgroundColor: theme.palette.primary.main,
                    },
                  },
                ]}
              >
                {t('Update')}
              </Button>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  ) : null;
}
